import QRCode from 'qrcode.react'

import type {CryptoCheckout} from './types'
import btcLogo from '../../assets/crypto/btc.png'
import ethLogo from '../../assets/crypto/eth.png'
import trxLogo from '../../assets/crypto/trx.png'
import usdtLogo from '../../assets/crypto/usdt.png'
import usdcLogo from '../../assets/crypto/usdc.png'

type Props = Pick<CryptoCheckout, 'qrCodeData' | 'digitalAsset'>

const ASSET_LOGO: Record<CryptoCheckout['digitalAsset'], string> = {
  BTC: btcLogo,
  ETH: ethLogo,
  TRX: trxLogo,
  'USDT/ERC20': usdtLogo,
  'USDT/TRC20': usdtLogo,
  'USDC/ERC20': usdcLogo,
}

export default function WalletAddressQRCode({qrCodeData, digitalAsset}: Props): JSX.Element {
  return (
    <QRCode
      value={qrCodeData}
      size={200}
      renderAs="svg"
      imageSettings={{
        src: ASSET_LOGO[digitalAsset],
        width: 30,
        height: 30,
        excavate: true,
      }}
    />
  )
}
